import React from 'react';
import {Link} from 'react-router-dom'

import './serviceBox.css';


export default function SerivceBox({title, linkto, imgSource}){
    return(
        <Link className="serviceContainer" to={linkto ? linkto : '#'}>
            {imgSource !== undefined ? <img src={imgSource} alt="" /> : null}
            <h5>{title}</h5>
        </Link>
    )
}